import Loadable from 'react-loadable'

import Loader from '../../components/Loading/List'

export default Loadable({
  loader: () => import('./components/Dashboard'),
  loading: Loader,
})
